// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.count_tiles[data-v-1f43377a] {
  gap: 25px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.count_tiles a[data-v-1f43377a] {
  color: #000;
  text-decoration: none;
}
.count_tiles p[data-v-1f43377a] {
  font-size: 20px;
  min-height: 50px;
}
.count_tiles img[data-v-1f43377a] {
  max-height: 130px;
}
.count_tiles .count_container[data-v-1f43377a] {
  min-height: 130px;
}
.count_tiles .img_card[data-v-1f43377a] {
  padding: 25px 30px;
}
.body_style_card[data-v-1f43377a] {
  border-radius: 10px;
}
.body_style_card h4[data-v-1f43377a] {
  font-size: 60px;
  opacity: 0.5;
}
.body_style_card.disabledContent[data-v-1f43377a] {
  pointer-events: none !important;
  opacity: 0.9 !important;
}
.body_style_card .cursor_pointer[data-v-1f43377a] {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/AiCountTiles.vue","webpack://./AiCountTiles.vue"],"names":[],"mappings":"AACA;EACE,SAAA;EACA,aAAA;EACA,qCAAA;ACAF;ADHA;EAMI,WAAA;EACA,qBAAA;ACAJ;ADPA;EAWI,eAAA;EACA,gBAAA;ACDJ;ADXA;EAgBI,iBAAA;ACFJ;ADdA;EAoBI,iBAAA;ACHJ;ADjBA;EA2BI,kBAAA;ACPJ;ADWA;EACE,mBAAA;ACTF;ADQA;EAII,eAAA;EACA,YAAA;ACTJ;ADYE;EACE,+BAAA;EACA,uBAAA;ACVJ;ADAA;EAcI,eAAA;ACXJ","sourcesContent":["\n.count_tiles {\n  gap: 25px;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n\n  a {\n    color: #000;\n    text-decoration: none;\n  }\n\n  p {\n    font-size: 20px;\n    min-height: 50px;\n  }\n\n  img {\n    max-height: 130px;\n  }\n\n  .count_container {\n    min-height: 130px;\n    // display: flex;\n    // align-items: center;\n    // justify-content: center;\n  }\n\n  .img_card {\n    padding: 25px 30px;\n  }\n}\n\n.body_style_card {\n  border-radius: 10px;\n\n  h4 {\n    font-size: 60px;\n    opacity: 0.5;\n  }\n\n  &.disabledContent {\n    pointer-events: none !important;\n    opacity: 0.9 !important;\n  }\n\n  .cursor_pointer {\n    cursor: pointer;\n  }\n\n}\n",".count_tiles {\n  gap: 25px;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n}\n.count_tiles a {\n  color: #000;\n  text-decoration: none;\n}\n.count_tiles p {\n  font-size: 20px;\n  min-height: 50px;\n}\n.count_tiles img {\n  max-height: 130px;\n}\n.count_tiles .count_container {\n  min-height: 130px;\n}\n.count_tiles .img_card {\n  padding: 25px 30px;\n}\n.body_style_card {\n  border-radius: 10px;\n}\n.body_style_card h4 {\n  font-size: 60px;\n  opacity: 0.5;\n}\n.body_style_card.disabledContent {\n  pointer-events: none !important;\n  opacity: 0.9 !important;\n}\n.body_style_card .cursor_pointer {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
